/**
 * Collapsible content functionality
 *
 * This file handles the "Read more"/"Read less" functionality used throughout the site.
 */

document.addEventListener('DOMContentLoaded', function() {
  // Initialize all collapsible content blocks on the page
  document.querySelectorAll('.collapsible-content').forEach(initializeCollapsibleContent);
});

/**
 * Initialize a collapsible content block
 * @param {HTMLElement} container - The collapsible content container
 */
function initializeCollapsibleContent(container) {
  if (!container) return;

  const content = container.querySelector('.collapsible-content__inner');
  const button = container.querySelector('.collapsible-content__button');

  if (!content || !button) return;

  const initialHeight = parseInt(container.dataset.initialHeight || 115);
  const contentHeight = content.offsetHeight;

  // Only apply collapse functionality if content is taller than the initial height
  // or if auto-detect is disabled (auto-detect is true by default)
  const autoDetect = container.dataset.autoDetect !== 'false';
  const shouldCollapse = !autoDetect || contentHeight > initialHeight;

  if (shouldCollapse) {
    // Initialize as collapsed
    container.classList.add('collapsible-content--collapsed');

    // Handle button click
    button.addEventListener('click', function() {
      const isExpanded = button.getAttribute('aria-expanded') === 'true';

      // Toggle state
      button.setAttribute('aria-expanded', !isExpanded);
      container.classList.toggle('collapsible-content--collapsed');
    });
  } else {
    // If content is not tall enough to need collapsing and auto-detect is enabled
    button.parentElement.style.display = 'none';
  }
}
